'use client'

import { useState } from 'react'
import { Glossary } from '../jbda/glossary'
import { Question } from './faq-question'

export function FAQ({ questions, background2, glossary }: { questions: Question[], background2?: boolean, glossary?: Glossary }) {
  const [opened, setOpened] = useState<number>(-1)

  return (
    <div className='w-full'>
      {questions.map((question, i) => (
        <Question
          key={i}
          index={i}
          question={question}
          opened={opened === i}
          setOpened={setOpened}
          background2={background2}
          glossary={glossary}
        />
      ))}
    </div>
  )
}
